export type FormationLevel = "Débutant" | "Intermédiaire" | "Avancé";
export type FormationFormat = "En ligne" | "Présentiel" | "Hybride";

export interface Formation {
  id: string;
  title: string;
  provider: string;
  providerLogo: string;
  image: string;
  level: FormationLevel;
  format: FormationFormat;
  duration: string;
  price: string;
  country: string;
  countryFlag: string;
  sector: string;
  description: string;
  skills: string[];
  link: string;
  featured?: boolean;
  certification?: boolean;
  partnerWazi?: boolean;
}

export const formations: Formation[] = [
  {
    id: "form-1",
    title: "Salesforce Administrator — Certification Officielle",
    provider: "Salesforce Trailhead",
    providerLogo: "https://public.readdy.ai/ai/img_res/c272b5a8a380d9992cffb0f1da6c5b92.jpg",
    image: "https://readdy.ai/api/search-image?query=Salesforce%20CRM%20training%20certification%20professional%20african%20student%20laptop%20modern%20office%20learning%20technology&width=600&height=380&seq=form1&orientation=landscape",
    level: "Intermédiaire",
    format: "En ligne",
    duration: "3 mois",
    price: "Gratuit",
    country: "Pan-Africain",
    countryFlag: "🌍",
    sector: "Tech / CRM",
    description: "Maîtrisez Salesforce, le CRM n°1 mondial. Formation officielle avec certification reconnue internationalement. Idéal pour booster votre carrière ou digitaliser votre entreprise.",
    skills: ["CRM", "Automatisation", "Rapports", "Gestion clients"],
    link: "https://trailhead.salesforce.com",
    featured: true,
    certification: true,
    partnerWazi: true,
  },
  {
    id: "form-2",
    title: "Odoo ERP — Gestion d'entreprise complète",
    provider: "Odoo Learning",
    providerLogo: "https://readdy.ai/api/search-image?query=Odoo%20ERP%20logo%20minimal%20clean%20purple%20modern%20brand%20identity%20professional%20software&width=80&height=80&seq=flogo2&orientation=squarish",
    image: "https://readdy.ai/api/search-image?query=Odoo%20ERP%20business%20management%20software%20training%20african%20entrepreneur%20modern%20office%20digital%20tools&width=600&height=380&seq=form2&orientation=landscape",
    level: "Débutant",
    format: "En ligne",
    duration: "6 semaines",
    price: "Gratuit",
    country: "Pan-Africain",
    countryFlag: "🌍",
    sector: "ERP / Gestion",
    description: "Gérez votre entreprise africaine avec Odoo : comptabilité, stocks, ventes, RH. La solution open-source adoptée par des milliers de PME africaines.",
    skills: ["ERP", "Comptabilité", "Gestion stocks", "RH", "Ventes"],
    link: "https://www.odoo.com/slides",
    featured: true,
    certification: true,
    partnerWazi: true,
  },
  {
    id: "form-3",
    title: "Entrepreneuriat Digital en Afrique — Bootcamp Wazi",
    provider: "Wazi Stories Afrique",
    providerLogo: "https://storage.readdy-site.link/project_files/5c942cfb-1ccb-4a1f-ae9b-6223a6645081/db57ada8-027e-48ac-9357-a295d5e6a211_wazi_stories_transparent.png?v=b6e6edf7454a9eb40d503dba8ed8f73a",
    image: "https://readdy.ai/api/search-image?query=african%20entrepreneur%20bootcamp%20training%20workshop%20young%20people%20laptop%20modern%20coworking%20space%20Abidjan%20Lagos%20Dakar%20vibrant&width=600&height=380&seq=form3&orientation=landscape",
    level: "Débutant",
    format: "Hybride",
    duration: "8 semaines",
    price: "50 000 FCFA",
    country: "Côte d'Ivoire",
    countryFlag: "🇨🇮",
    sector: "Entrepreneuriat",
    description: "Le bootcamp Wazi forme les entrepreneurs africains aux outils digitaux : création d'entreprise, marketing digital, financement, pitch investisseurs.",
    skills: ["Business plan", "Marketing digital", "Pitch", "Financement", "Réseaux sociaux"],
    link: "/soumettre",
    featured: true,
    certification: true,
    partnerWazi: true,
  },
  {
    id: "form-4",
    title: "Google Digital Skills for Africa",
    provider: "Google",
    providerLogo: "https://readdy.ai/api/search-image?query=Google%20logo%20minimal%20clean%20colorful%20modern%20brand%20identity%20professional&width=80&height=80&seq=flogo4&orientation=squarish",
    image: "https://readdy.ai/api/search-image?query=Google%20digital%20skills%20training%20africa%20young%20people%20smartphone%20laptop%20modern%20learning%20technology&width=600&height=380&seq=form4&orientation=landscape",
    level: "Débutant",
    format: "En ligne",
    duration: "40 heures",
    price: "Gratuit",
    country: "Pan-Africain",
    countryFlag: "🌍",
    sector: "Marketing Digital",
    description: "Acquérez les compétences numériques essentielles pour développer votre activité en ligne : SEO, publicité digitale, e-commerce, analytics.",
    skills: ["SEO", "Google Ads", "Analytics", "E-commerce", "Réseaux sociaux"],
    link: "https://learndigital.withgoogle.com/digitalskills",
    certification: true,
  },
  {
    id: "form-5",
    title: "Finance d'entreprise pour entrepreneurs africains",
    provider: "African Management Institute",
    providerLogo: "https://readdy.ai/api/search-image?query=african%20management%20institute%20logo%20minimal%20clean%20modern%20brand%20identity%20professional%20education&width=80&height=80&seq=flogo5&orientation=squarish",
    image: "https://readdy.ai/api/search-image?query=african%20business%20finance%20training%20entrepreneur%20professional%20modern%20classroom%20workshop%20Nairobi%20Lagos&width=600&height=380&seq=form5&orientation=landscape",
    level: "Intermédiaire",
    format: "En ligne",
    duration: "4 semaines",
    price: "199 USD",
    country: "Pan-Africain",
    countryFlag: "🌍",
    sector: "Finance",
    description: "Maîtrisez les fondamentaux de la finance d'entreprise : lecture des états financiers, gestion de trésorerie, levée de fonds, valorisation.",
    skills: ["Comptabilité", "Trésorerie", "Levée de fonds", "Valorisation"],
    link: "https://www.africanmanagers.org",
    certification: true,
  },
  {
    id: "form-6",
    title: "Intelligence Artificielle pour les PME africaines",
    provider: "Microsoft Africa",
    providerLogo: "https://readdy.ai/api/search-image?query=Microsoft%20logo%20minimal%20clean%20modern%20brand%20identity%20professional%20technology&width=80&height=80&seq=flogo6&orientation=squarish",
    image: "https://readdy.ai/api/search-image?query=artificial%20intelligence%20AI%20training%20african%20business%20professional%20modern%20technology%20laptop%20data&width=600&height=380&seq=form6&orientation=landscape",
    level: "Débutant",
    format: "En ligne",
    duration: "6 heures",
    price: "Gratuit",
    country: "Pan-Africain",
    countryFlag: "🌍",
    sector: "Tech / IA",
    description: "Découvrez comment l'IA peut transformer votre PME africaine : automatisation, analyse de données, chatbots, prédiction de ventes.",
    skills: ["IA", "Automatisation", "Data", "ChatGPT", "Azure"],
    link: "https://learn.microsoft.com",
    certification: false,
  },
];
